
import {Component, Prop, Vue} from "vue-property-decorator";

@Component({})
export default class UsersMosaicView extends Vue {
    @Prop({default: []})
    public selectedUsers: any;

    @Prop({default: false})
    public loading: boolean;

    @Prop({default: null})
    public companyId: number;

    @Prop({default: []})
    public users: any;

    get totalUsers() {
        return this.users.length;
    }

    private selectContact(contact) {
        this.$emit("select-contact", contact);
    }

    private checkIfSelected(contact) {
        return Boolean(this.selectedUsers.find((user) => user.id === contact.id));
    }

    private getInfo(user , info) {
        return user.Contact && user.Contact[info] !== null && user.Contact[info] !== "" ?
            user.Contact[info] : user[info];
    }
}
